<!--
 * @Description: 全球影响力模块
 * @Author: F-Stone
 * @LastEditTime: 2023-10-31 12:08:47
-->
<template>
  <div :class="$style['m-presence']">
    <div class="m-container">
      <div :class="$style['container-inner']">
        <div :class="$style['presence-list']">
          <div :class="$style['module-head']" class="flex justify-center">
            <div :class="$style['module-info']">
              <h2
                :class="$style['module-title']"
                class="enter-animate animate__fadeInUp"
              >
                <span class="text">
                    <!-- Global Presence -->
                    {{$t('300238')}}
                    </span>
              </h2>
              <h3
                :class="$style['module-subtitle']"
                class="enter-animate animate__fadeInUp"
              >
                <span class="text">
                  <!-- Borderless, community decentralization and autonomy, team
                  decentralization is the ultimate form of SuperEx development -->
                  {{$t('300239')}}
                </span>
              </h3>
            </div>
          </div>
          <div
            :class="$style['module-body']"
            class="enter-animate animate__fadeIn"
            :style="{
              animationDelay: '0.2s'
            }"
          >
            <div :class="$style['module-data']">
              <div :class="$style['tab-bar']" class="flex">
                <div
                  v-for="(item, index) in presenceList"
                  :key="index"
                  ref="tabItems"
                  :class="$style['tab-item']"
                  @click="goTo(index)"
                >
                  <span class="text">{{ $t(item.key) }}</span>
                </div>
                <div ref="moveShadow" :class="$style['move-shadow']"></div>
              </div>
              <div :class="$style['presence-list']">
                <div ref="swiperDom" class="swiper" :class="$style['swiper']">
                  <div class="swiper-wrapper">
                    <div
                      v-for="(item, index) in presenceList"
                      :key="index"
                      class="swiper-slide"
                    >
                      <div ref="listItems" :class="$style['list-item']">
                        <div :class="$style['list-item--inner']">
                          <div
                            :class="$style['item-icon']"
                            class="flex justify-center items-center"
                          >
                            <!-- <component
                              :is="item.icon"
                              :class="$style['icon']"
                            ></component> -->
                            <svg-icon
                              :icon-class="item.icon"
                              :class="$style['icon']"
                            />
                          </div>
                          <div :class="$style['item-info']">
                            <div
                              :class="$style['item-head']"
                              class="grid grid-flow-col-dense items-center"
                            >
                              <div :class="$style['item-title']">
                                <span class="text">{{ $t(item.title) }}</span>
                              </div>
                              <!-- <div :class="$style['item-tag']">
                                <span class="text">{{ item.tag }}</span>
                              </div> -->
                            </div>
                          </div>
                          <div ref="lightBox" :class="$style['light-box']">
                            <div :class="$style['light-l']"></div>
                            <div :class="$style['light-r']"></div>
                          </div>
                          <div :class="$style['item-desc']">
                            <span class="text">{{ $t(item.desc) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "../../../utils/swiper";
import { gsap } from "../../../utils/gsap";

import { presenceList } from "../../../data/presence";

export default {

  // defineOptions({
//     components: { Icon1, Icon2, Icon3, Icon4 },
// });
  data() {
    return {
      swiper: null,
      tabItems: null,
      presenceList: presenceList
    };
  },
  methods: {
    lightBoxEnter(target) {
      const lightBox = this.$refs.lightBox;
      const lightBoxDom = $(target).find($(lightBox))[0];
      const animateObj = {
        deg: parseFloat(
          lightBoxDom && lightBoxDom.style.getPropertyValue("--lighter-deg")
        )
      };
      gsap.to(animateObj, {
        deg: 6,
        duration: 0.6,
        onUpdate: () => {
          lightBoxDom &&
            lightBoxDom.style.setProperty(
              "--lighter-deg",
              `${animateObj.deg}deg`
            );
        }
      });
    },
    lightBoxOuter(target) {
      // const listItems = this.$refs.listItems;
      const lightBox = this.$refs.lightBox;
      const lightBoxDom = $(target).find($(lightBox))[0];
      const animateObj = {
        deg: parseFloat(
          lightBoxDom && lightBoxDom.style.getPropertyValue("--lighter-deg")
        )
      };
      gsap.to(animateObj, {
        deg: 0,
        duration: 0.6,
        onUpdate: () => {
          lightBoxDom &&
            lightBoxDom.style.setProperty(
              "--lighter-deg",
              `${animateObj.deg}deg`
            );
        }
      });
    },

    moveShadowDom(index = 0, transition = false) {
      // let swiper = null;
      const moveShadow = this.$refs.moveShadow;

      this.tabItems = this.$refs.tabItems;
      const dom = moveShadow;
      if (!dom) return;

      if (!transition) {
        $(dom).css({
          width: `${this.tabItems[index].offsetWidth}px`,
          height: 'auto',
          // height: `${this.tabItems[index].offsetHeight}px`,
          top: `${this.tabItems[index].offsetTop}px`,
          bottom: '4px',
          transform: `translateX(${this.tabItems[index].offsetLeft}px)`
        });
      } else {
        gsap.to(dom, {
          width: `${this.tabItems[index].offsetWidth}px`,
          height: 'auto',
          // height: `${this.tabItems[index].offsetHeight}px`,
          top: `${this.tabItems[index].offsetTop}px`,
          bottom: '4px',
          transform: `translateX(${this.tabItems[index].offsetLeft}px)`,
          duration: 0.36
        });
      }
    },

    goTo(index) {
      console.log(`index`, index);
      console.log(`this.swiper.slideTo`, this.swiper.slideTo);
      this.swiper && this.swiper.slideTo(index);
    }
  },
  mounted() {
    const listItems = this.$refs.listItems;
    // const swiperDom = this.$refs.swiperDom;
    const swiperDom = this.$refs.swiperDom;
    if (!swiperDom) return;
    this.swiper = new Swiper(swiperDom, {
      spaceBetween: 20,
      speed: 600,
      cssMode: true,
      on: {
        slideChange: () => {
          const index = (this.swiper && this.swiper.realIndex) || 0;
          this.moveShadowDom(index, true);
          $(this.tabItems)
            .removeAttr("data-active")
            .eq(index)
            .attr("data-active", "true");
        },
        beforeInit: () => {
          $(this.tabItems)
            .eq(0)
            .attr("data-active", "true");
          this.moveShadowDom();
          this.lightBoxEnter(listItems[0]);
        }
      }
    });
  },
  beforeDestroy() {
    this.swiper && this.swiper.destroy();
  }
};
</script>
<style lang="scss" module>
@import "../../../assets/uemo-scss/scss/abstracts/_mixins.scss";
@import "../../../assets/uemo-scss/scss/abstracts/_functions.scss";
@keyframes lighterEnter {
  0% {
    --lighter-deg: 0deg;
  }
  100% {
    --lighter-deg: 20deg;
  }
}
.m-presence {
  padding: 40px 0 214px;
  :global {
    .swiper,
    .swiper-container {
      overflow: visible !important;
    }
  }
  .module-head {
    margin-bottom: 80px;
  }
  .module-info {
    max-width: 525px;

    text-align: center;
    .module-title {
      font-size: 58px;
      font-weight: 700;
      line-height: 120%;
      color: #fff;
      letter-spacing: -1.04px;
    }
    .module-subtitle {
      font-size: 24px;
      line-height: 160%;

      margin-top: 25px;

      text-align: center;

      color: color(var(--g--color-font--default), 0.6);
    }
  }
  .list-item {
    position: relative;

    overflow: hidden;

    padding: 2px;

    border-radius: 20px;
    background-image: linear-gradient(
      170deg,
      rgba(#885e31, 0.3) 0%,
      rgba(#885e31, 0.1) 100%
    );
    &::after {
      @include ab-cover;
      z-index: 0;

      content: "";
      transition: 0.36s;

      background-image: conic-gradient(
        from var(--deg, 130deg) at 60% 40%,
        rgba(#885e31, 0.1),
        rgba(#885e31, 0.2),
        rgba(#885e31, 0.4),
        rgba(#ffa73d, 0.5),
        rgba(#ffdaae, 0.8),
        rgba(#ffdaae, 0.8),
        rgba(#ffa73d, 0.6),
        rgba(#ffa73d, 0.5),
        rgba(#885e31, 0.3),
        rgba(#885e31, 0.1)
      );
    // background-image: linear-gradient(143deg, rgba(231, 125, 0, 0.25) 21.31%, rgba(230, 124, 0, 0) 93.09%);
    // background-color: initial;
    }
    .list-item--inner {
      --inner-padding: 60px;
      position: relative;
      z-index: var(--g--z-index);

      overflow: hidden;

      padding: var(--inner-padding);

      border-radius: 20px;
      background-color: color(var(--g--color-bg--default));
      & > * {
        position: relative;
        border-radius: 20px;
        z-index: var(--g--z-index);
        overflow: hidden;
      }
      &::after {
        @include ab-cover;
        z-index: 0;
        overflow: hidden;
        content: "";
        transition: 0.36s;
        border-radius: 20px;
        // background: linear-gradient(#ff8c05, 255, 140, 5, #fa8700) !important;
        background: linear-gradient(143deg, #5e3e1e 21.31%, #282525 93.09%);
      }
    }
    
    .item-icon {
      @include square(80px);
      margin-bottom: 40px;
      .icon {
        flex: 0 0 auto;

        // width: 190px;
        width: 20.333vw;
        height: 20.333vh;
      }
    }
    .item-info {
      position: relative;
      z-index: var(--g--z-index);

      padding-bottom: 32px;

      border-bottom: 1px solid color(var(--g--color-font--default), 0.1);
    }
    .light-box {
      --lighter-deg: 6deg;
      --dis-deg: 0deg;
      --width: 536px;
      --move: 64px;
      position: relative;
      z-index: 0;
      left: calc(-1 * var(--inner-padding));

      width: var(--width);
      height: 1px;

      transition: opacity 0.36s ease;
      transform: translate3d(0, 0, 0);
      pointer-events: none;

      mix-blend-mode: color-dodge;
    }
    .light-r,
    .light-l {
      position: absolute;
      z-index: 1;
      bottom: -199.5px;

      overflow: hidden;

      width: var(--width);
      height: 502px;
      &::after {
        position: absolute;
        z-index: 0;
        top: 50px;

        width: 100%;
        height: 100%;

        content: "";
        transform: translate3d(0, 0, 0);

        background: conic-gradient(
          from 0deg at 50% 50%,
          rgba(#000, 1) 0deg,
          rgb(86, 86, 86) calc(127.363deg - var(--lighter-deg)),
          rgb(47, 47, 47) calc(231.791deg - var(--lighter-deg)),
          #aaa calc(358.9deg - var(--lighter-deg)),
          #f8f8f8 calc(359.6deg - var(--dis-deg)),
          #f8f8f8 calc(359.8deg - var(--dis-deg)),
          #f8f8f8 calc(359.9deg - var(--dis-deg)),
          rgba(#000, 1)
        );

        mix-blend-mode: color-dodge;
      }
    }
    .light-l {
      right: calc(var(--width) / 2);
      &::after {
        left: var(--move);

        transform: rotate(90deg);
      }
    }
    .light-r {
      left: calc(var(--width) / 2);
      &::after {
        right: var(--move);

        transform: rotate(-90deg) rotateY(180deg);
      }
    }
    .item-head {
      width: fit-content;

      gap: 18px;
    }
    .item-title {
      font-size: 36px;
      font-weight: 700;
      line-height: 140%;
      color: #fff;
      letter-spacing: -0.72px;
    }
    .item-tag {
      font-size: 18px;
      line-height: 1;

      position: relative;

      display: flex;

      padding: 10px 12px;
      padding-left: 10px;

      color: color(var(--g--color-theme--lighter));
      border: 1px solid color(var(--g--color-font--default), 0.4);
      border-radius: 100px;

      align-items: center;
      &::before {
        @include circle(6px);
        display: block;

        margin-right: 6px;

        content: "";

        background-color: color(var(--g--color-theme--lighter));
      }
    }
    .item-desc {
      font-size: 20px;
      font-weight: 400;
      line-height: 180%;

      padding-top: 40px;

      color: color(var(--g--color-font--default), 0.6);
    }
  }
  .tab-bar {
    position: relative;

    margin-bottom: 80px;
    padding: 8px;

    // border: 2px solid rgb(223 233 251 / 0.3);
    border: 2px solid #dfe9fb;
    border-radius: 56px;
    .move-shadow {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;

      width: 100px;
      height: 50px;

      border-radius: 100px;
    //   background-color: color(var(--g--color-theme--main));
         background-color: #FFC72B;
    }
    .tab-item {
        display: flex;
        align-items: center;
        justify-content: center;
      font-size: 24px;
      font-weight: 600;
      font-style: normal;
      line-height: 1;

      position: relative;
      z-index: var(--g--z-index);

      flex: 1 1 auto;

      width: 25%;
      padding: 20px;

      transition: 0.36s ease;
      text-align: center;

      color: color(var(--g--color-font--default), 0.6);
      &[data-active] {
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/index/PresenceModule.vue